import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../services/ServicePage.css';

function SystemsInstallation() {
  const navigate = useNavigate();
  const [showDemoForm, setShowDemoForm] = useState(false);
  const [demoFormData, setDemoFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: ''
  });
  const [demoMessage, setDemoMessage] = useState('');

  const handleDemoInputChange = (e) => {
    const { name, value } = e.target;
    setDemoFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDemoSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('http://localhost:5000/api/demo-request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...demoFormData,
          service: 'Systems Installation'
        })
      });
      const data = await response.json();
      if (data.success) {
        setDemoMessage('✓ Demo request submitted! We\'ll contact you within 24 hours.');
        setDemoFormData({ name: '', email: '', phone: '', company: '' });
        setTimeout(() => {
          setShowDemoForm(false);
          setDemoMessage('');
        }, 3000);
      }
    } catch (error) {
      setDemoMessage('Error submitting request. Please try again.');
    }
  };
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>Systems Installation</h1>
        <p>End-to-end systems installation for hospitals, hotels, schools, car booking platforms and POS systems.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Overview</h3>
          <p>We deliver full lifecycle systems installation: requirements, procurement, installation, testing, training and handover.</p>
        </section>

        <section className="service-section">
          <h3>What's Included</h3>
          <ul>
            <li>Custom configuration for hospital, hotel, school and POS environments</li>
            <li>Integration with existing infrastructure and third-party systems</li>
            <li>On-site commissioning, training and documentation</li>
          </ul>
        </section>

        <section className="service-section demo-section">
          <h3>Request a Live Demo</h3>
          <p>See our Systems Installation solution in action. Schedule a personalized live demo with our team.</p>
          {!showDemoForm ? (
            <button 
              className="demo-request-btn"
              onClick={() => setShowDemoForm(true)}
            >
              📅 Schedule Live Demo
            </button>
          ) : (
            <form onSubmit={handleDemoSubmit} className="demo-form">
              {demoMessage && <div className="demo-message">{demoMessage}</div>}
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={demoFormData.name}
                onChange={handleDemoInputChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={demoFormData.email}
                onChange={handleDemoInputChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Your Phone"
                value={demoFormData.phone}
                onChange={handleDemoInputChange}
                required
              />
              <input
                type="text"
                name="company"
                placeholder="Company Name"
                value={demoFormData.company}
                onChange={handleDemoInputChange}
                required
              />
              <button type="submit" className="demo-submit-btn">Submit Demo Request</button>
              <button 
                type="button" 
                className="demo-cancel-btn"
                onClick={() => setShowDemoForm(false)}
              >
                Cancel
              </button>
            </form>
          )}
        </section>

        <div className="service-cta">
          <a href="/contact">Request a Quote</a>
        </div>
      </div>
    </div>
  );
}

export default SystemsInstallation;
